<template>
    <el-form :inline="true" :model="queryParam" class="mainSearch">
      <el-form-item label="标题">
        <el-input v-model="queryParam.title" placeholder="输入标题" />
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="queryParam.checkstatus" placeholder="审核状态" style="width:120px">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="俱乐部状态" style="width:120px">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getListClub">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <div class="mainTableTop">
          <el-button
            type="primary"
            @click="(dialog = true), doClubAdd()"
            v-hasPermission="['club:add']"
            >创建俱乐部</el-button>
        </div>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBox">
      <el-col :span="24" class="mpadding">
        <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
          <el-table-column prop="title" label="标题"/>
          <el-table-column prop="coverUrl" label="Logo">
            <template #default="scope">
              <el-image :src="scope.row.coverUrl" style="width:50px;" />
            </template>
          </el-table-column>
          <el-table-column prop="area" label="地区"/>
          <el-table-column prop="cdate" label="成立日期"/>
          <el-table-column prop="usernum" label="成员数"/>
          <el-table-column prop="activitynum" label="活动数"/>
          <el-table-column prop="created" label="创建时间">
            <template #default="scope">
              <span
                v-text="
                  util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="checkstatus" label="审核状态" >
            <template #default="scope">
              <el-tag
                round
                :type="scope.row.checkstatus === 1 ? 'success' : 'danger'"
                disable-transitions
                ><span v-text="util.showCommonStatus(scope.row.checkstatus)"></span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" >
            <template #default="scope">
              <el-tag
                round
                :type="scope.row.status === 1 ? 'success' : 'danger'"
                disable-transitions
                ><span v-text="util.showCommonStatus(scope.row.status)"></span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template #default="scope">
              <el-link
              type="primary"
              @click="(dialog = true), doClubEdit(scope.$index, scope.row)"
              v-hasPermission="['club:edit']"
              >编辑</el-link>
  
              <el-popconfirm
                confirm-button-type="primary"
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon-color="#626AEF"
                title="您确定删除吗？"
                width="200px"
                @confirm="doClubDelete(scope.$index, scope.row)"
              >
                <template #reference>
                  <el-link
                    type="danger"
                    v-hasPermission="['club:delete']"
                    >删除</el-link
                  >
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBottom">
      <el-col :span="8">
        <!-- <div>
          <el-button type="primary">发布俱乐部</el-button>
        </div> -->
      </el-col>
      <el-col :span="16">
        <div style="float: right">
          <el-pagination
            :hide-on-single-page="false"
            v-model:page-size="queryParam.pageSize"
            :page-sizes="[10, 15, 20, 30]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changeChangeSize"
            @current-change="changePage"
          />
        </div>
      </el-col>
    </el-row>
  
    <el-drawer
      ref="drawerRef"
      v-model="dialog"
      :title="title"
      direction="rtl"
      :close-on-click-modal="false"
      size="60%"
      @close="doClubClose()"
    >
      <div class="common-drawer__content">
        <el-form
          ref="clubFormRef"
          :model="clubForm"
          :rules="rules"
          label-width="120px"
        >
        <el-form-item label="标题" prop="title">
            <el-input
              v-model.trim="clubForm.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面图" prop="coverUrl">
            <el-upload
              class="upload-demo"
              action="/api/upload/common"
              :auto-upload="true"
              ref="fileUpload1"
              :headers="headerUpload"
              :on-success="doUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/png, image/jpeg, image/jpg"
              name="picture"
            >
            <template #trigger>
              <el-button type="primary">选择图片</el-button>
            </template>
             
              <template #tip>
                <div class="el-upload__tip">
                  请上传Png、Jpeg、Jpg后缀名且小于1M的文件。
                </div>
              </template>
            </el-upload>
            <el-image v-if="clubForm.coverUrl" style="width: 120px;display: block;" :src="clubForm.coverUrl" />
          </el-form-item>
          <el-form-item label="地区" prop="area">
            <el-input
              v-model.trim="clubForm.area"
              placeholder="请输入地区"
            ></el-input>
          </el-form-item>
          <el-form-item label="成立日期" prop="cdate">
            <el-input
              v-model.trim="clubForm.cdate"
              placeholder="请输入成立日期"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动数" prop="activitynum">
            <el-input
              v-model.trim="clubForm.activitynum"
              placeholder="请输入活动数"
            ></el-input>
          </el-form-item>
          <el-form-item label="成员数" prop="usernum">
            <el-input
              v-model.trim="clubForm.usernum"
              placeholder="请输入成员数"
            ></el-input>
          </el-form-item>
          <el-form-item label="俱乐部介绍" prop="content">
            <el-input
              type="textarea"
              v-model.trim="clubForm.content"
              placeholder="请输入俱乐部介绍"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="checkstatus">
            <el-radio-group v-model="clubForm.checkstatus">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">未通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="clubForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="common-drawer__footer">
          <el-button @click="doClubClose()">关闭</el-button>
          <el-button type="primary" :loading="loading" @click="doClubSave">{{
            loading ? "提交中 ..." : "提交"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
  // import { useRouter } from "vue-router";
  import { ElDrawer, ElTable, ElMessage } from "element-plus";
  import { listClub, deleteClub,saveClub  } from "@/api/club";
    
  import util from "@/util/tool.js";
  // import storage from "@/util/storage.js";
  
  import store from "@/store";
  
  let timer;
  
  const dialog = ref(false);
  const loading = ref(false);
  const loadingData = ref(true);

  
  // const router = useRouter();
  // let open = (routeName, row) => {
  //   storage.saveSessionObject("clubPath",queryParam.value)
  //   router.push({
  //     name: routeName,
  //     params: { id: row.clubid },
  //     query: { eflag:row.eflag, name: row.name },
  //   });
  // };
  
  const drawerRef = ref(ElDrawer);
  
  const tableData = ref();
  const total = ref(0);
  const pageSize = ref(15); //每页显示条数
  
  let clubFormRef = ref();
  let title = ref("发布俱乐部");
  
  // const defaultSelectDepart = ref([])
  
  //onMounted方法
  onMounted(() => {
    getListClub();
  });
  
  
  //搜索查询
  const queryParam = ref({
    pageNo: 1,
    pageSize: pageSize.value,
    checkstatus:"",
    status: "",
    title: "",
  });
  const resetSearch = () => {
    queryParam.value = {
      pageNo: 1,
      pageSize: pageSize.value,
      checkstatus: "",
      status: "",
      title: "",
    };
    getListClub();
  };
  
  //俱乐部表单项
  let clubForm = ref({
    clubid: null,
    checkstatus: "",
    title: "",
    coverUrl: "",
    area: "",
    usernum: '',
    content: '',
    cdate: '',
    activitynum: "",
    status: 1,
  });
  
  //发布俱乐部
  const doClubAdd = () => {
    title.value = "创建俱乐部";
    // console.log('add',clubForm.value)
  
    // clubForm.value.content = ''
    // editorRef.value.valueHtml = '<p></p>'
    resetForm();
  };
  
  //编辑俱乐部
  const doClubEdit = (index, obj) => {
    title.value = "编辑俱乐部";
  
    clubForm.value = {
      clubid: obj.clubid,
      checkstatus: obj.checkstatus,
      title: obj.title,
      coverUrl: obj.coverUrl,
      area: obj.area,
      usernum: obj.usernum,
      content: obj.content,
      cdate: obj.cdate,
      activitynum: obj.activitynum,
      status: obj.status,
    };
  
  };
  const resetForm = () => {
    clubForm.value = {
      clubid: null,
      checkstatus: "",
      title: "",
      coverUrl: "",
      area: "",
      usernum: '',
      content: '',
      cdate: '',
      activitynum: "",
      status:1,
    };
  };
  
  //关闭俱乐部表单弹窗
  const doClubClose = () => {
    loading.value = false;
    dialog.value = false;
    clearTimeout(timer);
    clubFormRef.value.resetFields()
  };
  
  //保存俱乐部数据
  const doClubSave = () => {
    clubFormRef.value.validate((valid) => {
      if (!valid) {
        //ElMessage("请先完善表单数据填写！");
        return;
      }
      saveClub(clubForm.value).then((res) => {
        loading.value = true;
        timer = setTimeout(() => {
          // 动画关闭需要一定的时间
          setTimeout(() => {
            loading.value = false;
          }, 400);
          if (res.data.code === 1) {
            getListClub();
            doClubClose();
          } else {
            ElMessage.error(res.data.msg);
          }
        }, 1000);
      });
    });
  };
  
  //更新俱乐部状态
  const doClubDelete = (index, obj) => {
    // console.log('obj.clubid',obj.clubid.toString())
    deleteClub(obj).then((res) => {
      // console.log(res);
      if (res.data.code === 1) {
        getListClub();
      } else {
        ElMessage.error(res.data.msg);
      }
    });
  };
  
  //分页
  const changePage = (current) => {
    queryParam.value.pageNo = current;
    getListClub();
  };
  const changeChangeSize = (size) => {
    pageSize.value = size;
    queryParam.value.pageSize = size;
    getListClub();
  };
  
  //俱乐部列表API
  const getListClub = () => {
    listClub(queryParam.value).then((res) => {
      tableData.value = res.data.extend.pages.list;
      total.value = res.data.extend.pages.total;
      queryParam.value.pageSize = pageSize.value;
      loadingData.value = false
    });
  };
  
  //俱乐部表单验证规则
  const rules = ref({
    title: [
      {
        required: true,
        message: "请输入标题",
        trigger: "blur",
      },
      {
        min: 2,
        max: 200,
        message: "标题长度2到200",
        trigger: "blur",
      },
    ],
     coverUrl: [
      {
        required: true,
        message: "请上传俱乐部图",
        trigger: "blur",
      },
    ],
  });
  
  
  const filefail = ref("");
  const resultMsg = ref();
  const fileUpload1 = ref();
  const doUploadSuccess = (response) => {  
    if (response.code === 0) {    
      ElMessage.error(response.msg)
    } else {
      resultMsg.value = response.msg
      filefail.value = response.url
      clubForm.value.coverUrl = response.url
      setTimeout(function(){
        fileUpload1.value.clearFiles()
      },1000)
    }
  };
  const beforeUpload = (rawFile) => {
    if (rawFile.type !== 'image/png' && rawFile.type !=='image/jpeg' && rawFile.type !=='image/jpg') {
      ElMessage.error('请上传PNG、JPEG、JPG格式图片!')
      return false
    } else if (rawFile.size / 1024 / 1024 > 1) {
      ElMessage.error('请上传小于1MB的文件!')
      return false
    }
    resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
    return true
  }
  
  const headerUpload = ref({
    Authorization: store.state.user.token,
  })
  </script>
  